import { createNextTableContext } from '@core/table';

export const HandoverQueueTableContext = createNextTableContext();
